<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <HeadNav /><!-- 顶部导航-->

    <div class="hall">
      <DemandType
        :data="typeData"
        v-loading="typeLoading"
        @typeClick="typeClick"
      />
      <div class="hall-search">
        <SearchBarCircle
          :num="totalItem"
          v-model="searchKey"
          @btnClick="searchBarClick"
        />
      </div>
      <div class="hall-con">
        <el-row :gutter="0">
          <el-col :span="18">
            <el-empty
              v-if="tableData.length === 0"
              description="暂无数据"
            ></el-empty>
            <div v-else class="hall-list flex-1">
              <Demand
                v-for="(item, index) in tableData"
                :key="index"
                :data="item"
              />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="hall-news">
              <HallNews />
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 分页-->
      <Pagination
        :total="totalItem"
        :page="page"
        @pageIndexChange="handlePageChange"
      />
    </div>
    <FootBar class="footer" />
  </div>
</template>
<script>
import { demandList, abilityType } from "@/api/hall";
import SearchBarCircle from "@/components/SearchBarCircle/index";
import Pagination from "@/components/Pagination/index";
import DemandType from "./components/DemandType.vue";
import Demand from "@/components/DemandItem/index.vue";
import HallNews from "./components/HallNews.vue";
export default {
  components: {
    SearchBarCircle,
    DemandType,
    Pagination,
    Demand,
    HallNews,
  },
  data() {
    return {
      searchKey: "",
      tableData: [],
      firstTypeId: 0,
      totalItem: 0,
      demandTotal: 0,
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      tableLoading: true,
      typeData: [],
    };
  },
  created() {
    this.getType();
  },
  methods: {
    // 获取需求分类
    async getType() {
      this.typeLoading = true;
      const data = await this.$axios
        .get(abilityType, { pid: 0 })
        .finally(() => {
          this.typeLoading = false;
        });
      this.typeData = data;
      this.firstTypeId = data[0].laboratoryAbilityTypeId;
      this.getTableList();
    },
    // 获取需求列表
    async getTableList() {
      this.tableLoading = true;
      const params = {
        ...this.page,
        firstTypeId: this.firstTypeId || null,
        searchKey: this.searchKey,
      };
      const { list, totalItem, total } = await this.$axios.post(
        demandList,
        params
      );
      this.tableLoading = false;
      this.totalItem = totalItem;
      this.demandTotal = total;
      this.tableData = list || [];
    },
    // 检索bar的触发
    searchBarClick() {
      this.getTableList();
    },
    // 分页查询
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getTableList();
    },
    // 需求分类的点击
    typeClick(item) {
      this.firstTypeId = item.laboratoryAbilityTypeId;
      this.getTableList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.footer {
  padding-top: 0;
}
.hall {
  background: $home-bg;
  padding-top: 14px;
  padding-bottom: 20px;
  &-con {
    width: $max-width;
    margin: 0 auto;
  }
  &-list {
    margin-right: 20px;
    // display: flex;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  &-news {
    // width: 350px;
  }
  &-search {
    width: $max-width;
    margin: 0 auto;
    background: white;
    padding: 15px;
    margin-bottom: 15px;
    border-top: 1px solid #f3f3f3;
  }
}
</style>
